import type { CareNotes } from '../../types/careExpanded';

interface NotesSectionProps {
  notes: CareNotes;
}

export function NotesSection({ notes }: NotesSectionProps) {
  const hasAiNotes = !!notes.ai;
  const hasUserNotes = !!notes.user;

  if (!hasAiNotes && !hasUserNotes) {
    return (
      <p className="text-sm text-gray-500 italic">No notes yet</p>
    );
  }

  return (
    <div className="space-y-4">
      {/* AI-generated notes */}
      {hasAiNotes && (
        <div className="p-3 rounded-lg bg-primary/5 border border-primary/10">
          <div className="flex items-center gap-2 mb-1.5">
            <span className="text-primary text-xs font-medium uppercase tracking-wide">
              AI Observations
            </span>
          </div>
          <p className="text-sm text-editorial-black whitespace-pre-wrap">{notes.ai}</p>
        </div>
      )}

      {/* User notes */}
      {hasUserNotes && (
        <div className="p-3 rounded-lg bg-background border border-gray-200">
          <div className="flex items-center gap-2 mb-1.5">
            <span className="text-gray-500 text-xs font-medium uppercase tracking-wide">
              Your Notes
            </span>
          </div>
          <p className="text-sm text-editorial-black whitespace-pre-wrap">{notes.user}</p>
        </div>
      )}
    </div>
  );
}
